<div class="page-padding-s">
  <div *ngIf="title" class="mb-2 ">
    {{ title }} <app-badge>{{ updateCount }}</app-badge>
  </div>
  <div class="flex">
    <div class="h-5 w-7">
      <span *ngIf="displayBackArrow" class="pr-2 my-20 cursor-pointer material-symbols-rounded" (click)="onBackward()">{{ arrowBackIos }}</span>
    </div>

    <div #cardsContainer
      class="flex gap-5 pb-6 pr-10 overflow-x-auto scrollbar"
      style="width: calc(99vw - 8rem)"
      (scroll)="onScroll()"

    >
      <ng-content></ng-content>
    </div>
    <div class="h-10 w-7">
    <span *ngIf="displayForwardArrow" class="pl-2 my-20 cursor-pointer material-symbols-rounded" (click)="onForward()" >{{ arrowForwardIos }}</span>
    </div>
  </div>
</div>
